import { TimeListSecText } from './timeListSecText.model';
import { Serializable } from './deserialize.service';

export class TimeList implements Serializable<TimeList> {
    id: number;
    from: Date;
    primText: string;
    secText: TimeListSecText[];
    data: any;
    classColor: string;

    deserialize(input) {
        this.from = input.from;
        this.primText = input.primText;
        this.data = input.data;
        this.classColor = input.classColor;
        if (input.secText) {
            this.secText = input.secText.map((text) => (text = new TimeListSecText().deserialize(text)));
        }
        return this;
    }
}
